import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getPayrolls } from "../../../../../MyApi/hr/payrolls";

import SubPayrollsFilter from "../subpayrollsfilter";
import LoadingSpinner from "../../../../UI/spinner";
import SinglePayrolls from "../singlepayrolls";


import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

import classes from "./payrollsDataTable.module.css";

const PayrollsDataTable = () => {
  const [sb_department_id, setSbDepartmentId] = useState("");
  const [sb_branch_id, setSbBranchId] = useState("");
  const [years, setYears] = useState("");
  const { t } = useTranslation();
  const { data, isLoading, refetch ,error } = useQuery(
    ["getPayrolls", sb_department_id, sb_branch_id, years],
    () => getPayrolls(sb_department_id, sb_branch_id, years)
  );


  const payrolls = data?.data || [];
  const responeMessage =data?.message 

  if(isLoading){
    return <LoadingSpinner/>
  }

  if(payrolls.length ===0){
    return <NoData responeMessage={responeMessage}/>
  }
  if(error){
    return <ErrorMessage error={error}/>
  }
  return (
    <div className="container-fluid">
      <SubPayrollsFilter
        setSbDepartmentId={setSbDepartmentId}
        setSbBranchId={setSbBranchId}
        branchId={sb_branch_id}
        setYears={setYears}
      />
      <div className="row">
        { isLoading ? (
              <LoadingSpinner />
            ) : (
          <>
            {!data ? (
          <div>no data available</div>
        ) :
            
            (
              <>
                {payrolls.map((Payroll, index) => (
                  <SinglePayrolls
                    key={Payroll.id}
                    index={index}
                    Payroll={Payroll}
                    classes={classes}
                    refetch={refetch}
                  />
                ))}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PayrollsDataTable;
